import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    prescriptions: [],
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalPrescriptions: 0,
        hasNext: false,
        hasPrev: false,
    },
    lastCreatedPrescription: null,
    recentPrescriptions: [],
    currentPrescription: null,
    loading: false,
    error: null,
    status: "idle",
};

const prescriptionSlice = createSlice({
    name: "prescription",
    initialState,
    reducers: {
        setPrescriptions: (state, action) => {
            state.prescriptions = action.payload.prescriptions;
            state.pagination = action.payload.pagination;
            state.status = "succeeded";
        },
        setLastCreatedPrescription: (state, action) => {
            state.lastCreatedPrescription = action.payload;
            state.status = "succeeded";
        },
        clearLastCreatedPrescription: (state) => {
            state.lastCreatedPrescription = null;
        },
        setRecentPrescriptions: (state, action) => {
            state.recentPrescriptions = action.payload;
        },
        setCurrentPrescription: (state, action) => {
            state.currentPrescription = action.payload;
        },
        clearCurrentPrescription: (state) => {
            state.currentPrescription = null;
        },
        setPrescriptionLoading: (state, action) => {
            state.loading = action.payload;
            state.status = action.payload ? "loading" : "idle";
        },
        setPrescriptionError: (state, action) => {
            state.error = action.payload;
            state.status = "failed";
        },
    },
});

export const {
    setPrescriptions,
    setLastCreatedPrescription,
    clearLastCreatedPrescription,
    setRecentPrescriptions,
    setCurrentPrescription,
    clearCurrentPrescription,
    setPrescriptionLoading,
    setPrescriptionError,
} = prescriptionSlice.actions;

export default prescriptionSlice.reducer;
